import { getCorrectFilePath } from "@/helpers/new/getCorrectFilePath"
import { getAvatar } from "@common/Chat/helpers"
import { Image } from "antd"
import s from './FileView.module.css'
import AudioPlayer from "@UI/AudioPlayer"
import { useState } from "react"

const getAudioDuration = (file) => {
    const duration = Number(
        file?.durationSec
        ?? file?.duration_sec
        ?? file?.durationSeconds
        ?? file?.duration_seconds
        ?? file?.audioDuration
        ?? file?.audio_duration
        ?? file?.metadata?.duration
        ?? file?.meta?.duration
        ?? 0,
    );

    if (!Number.isFinite(duration) || duration <= 0) return undefined;
    return duration > 1000 ? duration / 1000 : duration;
}

const getImageKey = (file) => file?.id ?? file?.path ?? file?.name

const MessageImage = ({ file, width, height, borderRadius, onClick }) => {
    const [aspectRatio, setAspectRatio] = useState(4 / 3)
    const src = getAvatar(file.path, '')

    if (height) {
        return (
            <Image
                width={width}
                height={height}
                src={src}
                style={{
                    borderRadius: borderRadius,
                    objectFit: 'contain',
                    maxHeight: height,
                    maxWidth: '100%',
                }}
                onClick={onClick}
            />
        )
    }

    return (
        <div
            className={s.imageFrame}
            style={{
                width,
                maxWidth: '100%',
                aspectRatio,
                borderRadius,
            }}
        >
            <Image
                width="100%"
                height="100%"
                src={src}
                style={{
                    borderRadius,
                    objectFit: 'contain',
                }}
                onLoad={(event) => {
                    const image = event.currentTarget
                    if (image?.naturalWidth && image?.naturalHeight) {
                        setAspectRatio(image.naturalWidth / image.naturalHeight)
                    }
                }}
                onClick={onClick}
            />
        </div>
    )
}

export const FileView = ({files, isAutor = false, width = 200, height, borderRadius = '14px'}) => {

    const nadleClick = (e) => {
        e.stopPropagation()
    }
    
    if(!Array.isArray(files)) return <></>;

    return(
        <div style={{alignItems: isAutor ? 'flex-end' : undefined}} className={s.messageImages}>
            {
                files?.map((file, i) => {
                    const fileType = String(file?.type || file?.mime_type || '');

                    if(fileType.includes('image')){
                        return (
                            <Image.PreviewGroup key={getImageKey(file) ?? i}>
                                <MessageImage
                                    file={file}
                                    width={width}
                                    height={height}
                                    borderRadius={borderRadius}
                                    onClick={(e) => nadleClick(e)}
                                />
                            </Image.PreviewGroup>
                        )
                    }
                    
                    if(fileType.includes('audio')){
                        return (
                            <div key={file.id} className={s.audioMessage} onClick={(e) => nadleClick(e)}>
                                <AudioPlayer audioTrack={getCorrectFilePath(file.path)} durationSec={getAudioDuration(file)} />
                            </div>
                        )
                    }
                    return (
                        <a 
                                onClick={(e) =>nadleClick(e)}

                                className={s.messageLink} href={getCorrectFilePath(file.path)}
                                target={'black'}
                                rel={'noopener noreferrer'}
                                key={file.id}
                            >
                                {file?.original || file?.original_name}
                        </a>
                    )
                })
            }           
        </div>
    )
}

